import React from 'react'
import ServiceSlider from '../sliders/ServiceSlider'

const ServicesSection = () => {
  return (
    <div className='w-full bg-gray-50/50 md:py-15 py-10'>
         <ServiceSlider/>
    </div>
  )
}

export default ServicesSection